import React, { useState } from 'react';
import { setGlobal, addReducer, useDispatch } from 'reactn';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import ErrorBoundary from '@/lib/shared-coms/ErrorBoundary';
import apolloClientFunc from './Apollo.utils';
import App from './App';
import { RootProvider } from '@/lib/providers/RootProvider';
import { LOCAL_API_ORIGIN } from '@/lib/utils/localApiOrigin';

const ENV_SERVER = window.location.origin.includes('localhost')
  ? LOCAL_API_ORIGIN
  : window.location.origin;

addReducer('logout', async () => ({
  userSession: null
}));
setGlobal({
  userSession: null,
  serverUrl: ENV_SERVER
});

const ApolloSetup = () => {
  const logout = useDispatch('logout');
  const [initiatedClient] = useState(apolloClientFunc(logout));
  return (
    <ErrorBoundary>
      <Router>
        <ApolloProvider client={initiatedClient}>
          <RootProvider>
            <App />
          </RootProvider>
        </ApolloProvider>
      </Router>
    </ErrorBoundary>
  );
};

export default ApolloSetup;
